import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const KPIModal = ({ closePopup }) => {
  const [kpiData, setKpiData] = useState([]);
  const [kpiFormData, setKpiFormData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const getServiceNo = () => {
    const serviceNo = localStorage.getItem("serviceNo");
    if (serviceNo) {
      return serviceNo;
    }
    return localStorage.getItem("username");
  };

  useEffect(() => {
    const missingValues = [];
    if (!localStorage.getItem("year")) missingValues.push("Year");
    if (!localStorage.getItem("period")) missingValues.push("Period");

    if (missingValues.length > 0) {
      const formattedText =
        missingValues.length === 1
          ? missingValues[0]
          : missingValues.length === 2
            ? missingValues.join(" and ")
            : missingValues.slice(0, -1).join(", ") +
            ", and " +
            missingValues.slice(-1);

      Swal.fire({
        title: "Warning!",
        text: `Please select "${formattedText}" before proceeding.`,
        icon: "warning",
      });
    }
  }, []);

  useEffect(() => {
    const fetchKPIData = async () => {
      const serviceNo = getServiceNo();
      const year = localStorage.getItem("year");
      const period = localStorage.getItem("period") || "2";
      const userType = localStorage.getItem("userType") || "Ex";
      const requestToken = localStorage.getItem("request_token");
      let diviCode = localStorage.getItem("DivisionCode") || localStorage.getItem("DiviCode") || "";
      let depCode = localStorage.getItem("DepartmentCode") || localStorage.getItem("DepCode") || "";

      if (!serviceNo || !year || !requestToken) {
        setLoading(false);
        return;
      }

      try {

        const apiUrl = `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/GetKPIDetails?year=${year}&serviceNo=${serviceNo}&peroid=${period}&UserType=${userType}`;
        const response = await fetch(apiUrl, {
          headers: { request_token: requestToken },
        });

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const data = await response.json();

        let formApiUrl = `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/KpiFormLoad?year=${year}&KPI_Divition=${diviCode}&KPI_Department=${depCode}&UserType=${userType}`;

        if (data.ResultSet?.some(kpi => kpi.KPI_Criteria === "S")) {
          formApiUrl += `&serviceNo=${serviceNo}`;
        }


        const formResponse = await fetch(formApiUrl, {
          headers: { request_token: requestToken },
        });

        if (!formResponse.ok) throw new Error(`HTTP error! status: ${formResponse.status}`);

        const formData = await formResponse.json();


        if (!formData.ResultSet || formData.ResultSet.length === 0) {
          setKpiData([]);
          setLoading(false);
          return;
        }


        const processedData = data.ResultSet.filter(kpi =>
          formData.ResultSet.some(formItem => formItem.KPI_Code === kpi.KPI_Code)
        ).map(kpi => {
          const matchingFormItem = formData.ResultSet.find(item => item.KPI_Code === kpi.KPI_Code);

          return {
            ...kpi,
            KPI_GTitle: matchingFormItem?.KPI_GTitle || `${kpi.KPI_Code} - ${kpi.KPI_GTitle}`,
            KPI_Score: matchingFormItem ? kpi.KPI_Score : kpi.KPI_Score,
          };
        });

        setKpiData(processedData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load KPI data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchKPIData();
  }, []);



  const getCriteriaLabel = (criteria) => {
    switch (criteria) {
      case "D":
        return "Division Criteria";
      case "E":
        return "Departmental Criteria";
      case "S":
        return "Self Target Criteria";
      default:
        return "Unknown Criteria";
    }
  };

  const getCriteriaShortLabel = (criteria) => {
    switch (criteria) {
      case "D":
        return "Division Criteria";
      case "E":
        return "Departmental Criteria";
      case "S":
        return "Self Target Criteria";
      default:
        return "?";
    }
  };

  const sortedData = [...kpiData].sort((a, b) =>
    a.KPI_Criteria.localeCompare(b.KPI_Criteria)
  );

  const handleEditClick = () => {
    navigate(`/kpi-entry`);
  };

  const handleClose = () => {
    navigate("/executive");
    closePopup();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white p-6 rounded-lg shadow-lg w-11/12 max-w-6xl overflow-y-auto max-h-[90vh]">
        <button
          className="absolute top-2 right-2 text-red-500 text-2xl font-bold focus:outline-none"
          onClick={handleClose}
        >
          &times;
        </button>
        <h2 className="text-xl font-bold mb-6">KPI</h2>
        {loading ? (
          <div className="flex justify-center items-center py-4">
            <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : error ? (
          <div className="text-red-500 text-center py-4">{error}</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border border-gray-300 px-4 py-2 text-left">
                    Criteria
                  </th>
                  <th className="border border-gray-300 px-4 py-2 text-left">
                    Goal Title
                  </th>
                  <th className="border border-gray-300 px-4 py-2 text-left">
                    Full Score
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.length > 0 ? (
                  sortedData.map((kpi, index, arr) => {
                    const showCategoryHeader =
                      index === 0 ||
                      kpi.KPI_Criteria !== arr[index - 1].KPI_Criteria;
                    return (
                      <React.Fragment key={index}>
                        {showCategoryHeader && (
                          <tr className="bg-gray-200 font-semibold">
                            <td
                              colSpan="3"
                              className="border border-gray-300 px-4 py-2 text-left"
                            >
                              {getCriteriaLabel(kpi.KPI_Criteria)}
                            </td>
                          </tr>
                        )}
                        <tr
                          className={
                            index % 2 === 0 ? "bg-white" : "bg-gray-50"
                          }
                        >
                          <td className="border border-gray-300 px-4 py-2">
                            {getCriteriaShortLabel(kpi.KPI_Criteria)}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {kpi.KPI_GTitle}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {kpi.KPI_Score}
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="3"
                      className="border border-gray-300 px-4 py-2 text-center"
                    >
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
        <div className="flex mt-6 justify-end space-x-1">
          <button
            className="bg-blue-500 text-white px-3 py-2 rounded mt-4"
            onClick={handleEditClick}
          >
            Edit
          </button>
          <button
            className="bg-red-500 text-white px-3 py-2 rounded mt-4"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default KPIModal;